import React from 'react';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import PreRegistrationCampaign from './PreRegistrationCampaign';

function PreRegistrationCampaignPage() {
  return (
    <>
      <Can I="edit" a="WhatsappCampaign">
        {() => <PreRegistrationCampaign />}
      </Can>
      <Can not I="edit" a="WhatsappCampaign">
        {() => <NotPermissionPage />}
      </Can>
    </>
  );
}

export default PreRegistrationCampaignPage;
